import { LatencyTest } from './latency-test-element.js'
window.LatencyTest = LatencyTest
